import {
  Box,
  BoxProps,
  Button,
  LinearProgress,
  Paper,
  Typography,
} from '@mui/material';
import { linearProgressClasses } from '@mui/material/LinearProgress';
import { alpha, styled } from '@mui/material/styles';

export const StyledProgress = styled(LinearProgress)(({ theme }) => ({
  marginTop: '20px',
  height: 14,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    borderRadius: 8,
    border: `1px solid ${theme.palette.secondary.main}`,
    backgroundColor: '#FAFCFF',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 8,
    backgroundColor: theme.palette.secondary.main,
  },
}));

export const PaperQuestions = styled(Paper)(({ theme }) => ({
  height: '560px',
  overflowY: 'auto',
  backgroundColor: '#FFFFFF',
  border: '1px solid #D7D8DB',
  borderRadius: '16px',
  marginBottom: '20px',
  '&::-webkit-scrollbar': {
    width: '12px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  '&::-webkit-scrollbar-track': {
    margin: '6px 0',
  },
  [theme.breakpoints.up('xl')]: {
    height: '660px',
  },
}));

interface QuestionsBoxProps extends BoxProps {
  open: boolean;
}

export const QuestionsBox = styled(Box)<QuestionsBoxProps>(
  ({ open, theme }) => ({
    cursor: 'pointer',
    backgroundColor: '#FFFFFF',
    ...(open && {
      backgroundColor: alpha(theme.palette.common.grey, 0.2),
    }),
  })
);

export const SelectTypography = styled(Typography)(() => ({
  margin: '40px',
  fontSize: '21px',
  color: '#8B8C8E',
}));

export const NavigationBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  margin: '20px',
  gap: '10px',
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  minWidth: '32px',
  width: '48px',
  height: '42px',
  display: 'flex',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: '16px',
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));
